import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/physicalEducationPageImages/bgImage-2.png");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/physicalEducationPageImages/bgImageMobile-2.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/FooterCard/FooterCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/VideoPlayer/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/PhysicalEducationPageComponents/PhyTable/PhyTable.tsx");
